import { useCallback } from 'react';
import { useUiStore } from '../../stores/uiStore';
import { useOrdersUiStore } from '../../portals/orders/ordersUiStore';
import { useProjectsUiStore } from '../../portals/projects/projectsUiStore';
import { requestQcHomeView } from '../../portals/qc/qcHomeOpenBridge';
import { navigateHomeDestination } from './model/homeNavigation';
import { prepareHomeOrdersAddress } from './model/homeOrdersAddress';

export function useHomeNavigation({canAccessPortal,onSelectPortal,isQcManager=false}) {
  return useCallback(id => navigateHomeDestination(id,{
    canAccessPortal,onSelectPortal,isQcManager,
    ui:useUiStore.getState(),orders:useOrdersUiStore.getState(),projects:useProjectsUiStore.getState(),
    requestQc:requestQcHomeView,prepareOrders:prepareHomeOrdersAddress,
  }),[canAccessPortal,onSelectPortal,isQcManager]);
}
